/**
 * English strings for the `admin` namespace. The source of truth: French is
 * typed against this file. See `apps/web/src/i18n/README.md`.
 */
const admin = {
  title: "Back-office",
  intro: "Approve companies, manage their workspaces, and manage the people in them.",
  tabs: {
    invite: "Invitations",
    requests: "Access requests",
    tenants: "Workspaces",
    people: "People",
  },
  suspended: "Suspended",
  suspend: "Suspend",
  restore: "Restore",
  revoke: "Revoke",
  when: {
    never: "never",
    today: "today",
    yesterday: "yesterday",
    daysAgo_one: "{{count}}d ago",
    daysAgo_other: "{{count}}d ago",
  },
  tenants: {
    loadError: "Couldn't load workspaces",
    empty: "No workspaces yet. Approving an access request creates the first one.",
    renameAria: "Rename {{name}}",
    people_one: "<num>{{count}}</num> person",
    people_other: "<num>{{count}}</num> people",
    recordings_one: "<num>{{count}}</num> recording",
    recordings_other: "<num>{{count}}</num> recordings",
    stored: "<num>{{size}}</num> stored",
    lastRecorded: "last recorded {{when}}",
    suspendQuestion:
      "Suspend <strong>{{name}}</strong>? Everyone in it — including its owner — loses access immediately. Their recordings are kept, and restoring gives it all back.",
    reasonPlaceholder: "Reason (shown to nobody, kept for your reference)",
    suspendWorkspace: "Suspend workspace",
  },
  people: {
    searchPlaceholder: "Search by name or email…",
    loadError: "Couldn't load people",
    empty: "Nobody matches that.",
    operator: "Operator",
    noWorkspace: "Not in any workspace",
    makeOperatorTitle: "Give this person access to the back-office",
    makeOperator: "Make operator",
    removeOperatorTitle: "Remove back-office access",
    removeOperator: "Remove operator",
    makeOperatorQuestion:
      "Make <strong>{{email}}</strong> a platform operator? They will be able to see and manage every workspace on the platform, and every person in them.",
    suspendQuestion:
      "Suspend <strong>{{email}}</strong>? They are signed out immediately and cannot sign in again, in any workspace.",
    suspendAccount: "Suspend account",
  },
  invitations: {
    title: "Invite someone",
    body: "They get a link to set a password and name their own workspace, and become its owner — free to invite their own colleagues afterwards.",
    email: "Email",
    emailPlaceholder: "founder@company.com",
    name: "Their name <muted>(optional)</muted>",
    namePlaceholder: "Sam Patel",
    note: "Note <muted>(optional, shown in the email)</muted>",
    notePlaceholder: "Great speaking today — here is your access.",
    send: "Send invitation",
    failed: "Could not send that.",
    resent: "Invitation resent to {{email}}",
    sent: "Invited {{email}}",
    joined: "Joined",
    joinedOrg: "Joined · {{organization}}",
    revoked: "Revoked",
    expired: "Expired",
    waiting: "Waiting",
  },
  access: {
    title: "Access requests",
    intro: "Approving creates the workspace and invites the requester as its owner.",
    status: {
      pending: "pending",
      approved: "approved",
      rejected: "rejected",
    },
    loadError: "Couldn't load access requests",
    emptyTitle: {
      pending: "No pending requests",
      approved: "No approved requests",
      rejected: "No rejected requests",
    },
    emptyDescription: {
      pending: "New requests from the marketing site appear here.",
      approved: "Nothing has been approved yet.",
      rejected: "Nothing has been rejected yet.",
    },
    approve: "Approve",
    reject: "Reject",
    newWorkspace: "New workspace",
    name: "Name",
    address: "Address",
    addressInvalid: "Letters, numbers and hyphens only — and not a reserved name.",
    addressHelp: "Their workspace's own address. Permanent once created.",
    approveFailed: "Could not approve that request.",
    createAndInvite: "Create and invite",
  },
} as const;

export default admin;
